import "./core/constants"
import "./core/functions"

import Preloader from "./components/preloader"
import Scroll from "./components/scroll"
import Share from './components/share'

window.SCROLL = new Scroll()
export default class Layout {
    constructor() {
        this.preloader = new Preloader()
        this.share = new Share()
    }

    pageShow(e) {
        let historyTraversal = e.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2)
        if (historyTraversal) this.reload()
        else this.loaded()
    }

    reload(e) {
        return window.location.reload()
    }

    loaded() {
        this.preloader.hide(() => this.resize())
    }
}